import { LOCAL } from "@/store/mutations";

const { SET_TRACKER_PAID, SET_TRACKER_TOPAY, SET_TRACKER_OVERAGE, SET_TRACKER_COVERAGEGAP } = LOCAL;

export default {
	namespaced: true,
	state: () => ({
		amount: 0,
		paid: 0,
		toPay: 0,
		overage: 0,
		coverageGap: 0,
		coveragePercent: 1,
	}),
	getters: {
		remaining: (state) => state.amount - (state.paid + state.toPay),
		met: (state) => state.amount === state.paid,
		willMeet: (state) => state.toPay > 0 && (state.toPay + state.paid) === state.amount,
	},
	actions: {
		calculate({ commit, state, getters }, damage) {
			const covered = damage.cost * state.coveragePercent;
			const coverageGap = damage.cost - covered;
			const toPay = Math.min((covered + state.toPay), getters.remaining);
			const overage = state.overage + (damage.cost - toPay - coverageGap);

			commit(SET_TRACKER_TOPAY, { amount: toPay, coverageGap });
			commit(SET_TRACKER_COVERAGEGAP, { amount: coverageGap });
			commit(SET_TRACKER_OVERAGE, { amount: overage });
		},
		track({ commit, state }, payment = {}) {
			const amount = payment.amount || state.paid + state.toPay;

			commit(SET_TRACKER_PAID, { amount });
			commit(SET_TRACKER_TOPAY, { amount: 0 });
			commit(SET_TRACKER_OVERAGE, { amount: 0 });
			commit(SET_TRACKER_COVERAGEGAP, { amount: 0 });
		},
		reset({ commit }) {
			commit(SET_TRACKER_PAID, { amount: 0 });
		},
	},
	mutations: {
		[SET_TRACKER_PAID](state, payment) {
			state.paid = payment.amount;
		},
		[SET_TRACKER_TOPAY](state, payment) {
			state.toPay = payment.amount;
		},
		[SET_TRACKER_OVERAGE](state, overage) {
			state.overage = overage.amount;
		},
		[SET_TRACKER_COVERAGEGAP](state, gap) {
			state.coverageGap = gap.amount;
		},
	},
};
